import axios from "axios";
import { tmsApi, localApi } from "../api";


export const getCarTrackingByServicecity = (obj) => {
    const config = {
        headers: {
            // Authorization: `Bearer ${localStorage.getItem("token")}`,
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .get(tmsApi + `v1/entities/trackingExceptionTimeByServiceCity/${obj.serviceCityId}/${obj.cabType}`, config)
            .then((resp) => {
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getCarTrackingByLocation = (obj) => {
    const config = {
        headers: {
            // Authorization: `Bearer ${localStorage.getItem("token")}`,
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            // .post(tmsApi + `v1/entities/carcurrentstatus/latlng`, obj, config)
            .post(tmsApi + `v1/entities/gpslocation/latlng`, obj, config)
            .then((resp) => {
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getCarsByCarNumber = (obj) => {
    const config = {
        headers: {
            // Authorization: `Bearer ${localStorage.getItem("token")}`,
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .get(tmsApi + `v1/entities/search/cars/${obj.query}/${obj.serviceCityId}`, config)
            .then((resp) => {
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getCarByCarNumber = (obj) => {
    const config = {
        headers: {
            // Authorization: `Bearer ${localStorage.getItem("token")}`,
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            // .get(tmsApi + `v1/entities/carcurrentstatus/find?carNo=${obj.carNumber}`, config)
            .get(tmsApi + `v1/entities/gpslocation/find/cab/${obj.carNumber}`, config)
            .then((resp) => {
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};